import { SUBMIT_EMAIL } from 'state/actions/homeActions';

// THis is here for debugging.  Just enter it in the initial
// state as `submitEmail` and you'll be able to navigate to any
// page.
const successState = {
  success: true,
  inserted_at: "2017-09-28T03:10:12.287054",
  code: "264b46ff-25c3-46dc-985d-253ffb05c112",
  email: 'hughfrancis89@gmail.com',
  position: 'hero'
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const initialEmailParam = getParameterByName('email');

const initialApplicationState = {
  submitEmail: null,
  initialEmailValue: initialEmailParam
};

export default function applicationState(state = initialApplicationState, action) {
  switch (action.type) {
    case `${SUBMIT_EMAIL}_REJECTED`:
      return initialApplicationState;
    case `${SUBMIT_EMAIL}_PENDING`:
      return { ...state, submitEmail: { email: action.meta.emailAddress, position: action.meta.position } };
    case `${SUBMIT_EMAIL}_FULFILLED`:
      return {
        ...state,
        submitEmail: {
          ...state.submitEmail,
          ...action.payload
        }
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/applicationReducer.js